var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "spnod-admin__form--main d-flex align-items-center flex-column",
    attrs: {
      "id": "login-main"
    }
  }, [_c('h3', {
    staticClass: "h3 mb-4"
  }, [_vm._v("Payment")]), _vm._v(" "), _c('PaymentForm')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-986ac394","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/AdminAuth/Payment.vue
// module id = KmCz
// module chunks = 2